import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

import {LeaveDetail, LeaveHistory, LeaveHistoryUserType} from '../classes/leave-history';
import {SelectItem} from "primeng/api";
import {DatePipe} from "@angular/common";
import {DateService} from "@app/shared/services/date.service";
import {Format} from "@app/shared/enums/format.enum";
import {Calendar, QueryResult} from "@app/shared";

@Injectable()
export class LeaveHistoryDataService {
  Format: typeof Format = Format;

  constructor(private http: HttpClient, private datepipe: DatePipe, private dateService: DateService) {
  }

  getTimesheetPeriodsByYear(year: string): Observable<QueryResult> {
    const url = `/finance/timesheets/periods?year=${year}`;
    return this.http.get<QueryResult>(url);
  }

  convertTimesheetPeriodToDropdown(timesheetPeriods: Calendar[]): SelectItem[] {
    let tsPeriods: SelectItem[] = [];

    for (const period of timesheetPeriods) {
      const startOnInUTC = this.datepipe.transform(this.dateService.convertStringDateToUTCDate(period.start), Format.TimesheetDate, Format.TimeZone);
      const endOnInUTC = this.datepipe.transform(this.dateService.convertStringDateToUTCDate(period.end), Format.TimesheetDate, Format.TimeZone);
      tsPeriods.push({label: period.title + ": " + startOnInUTC + ' to ' + endOnInUTC, value: period.id});
    }
    return tsPeriods;
  }

  getLeaveHistory(userType: LeaveHistoryUserType, userId: number, year: string): Observable<QueryResult | LeaveHistory> {
    let url = '/hr/leave-histories/';
    const yearQueryParam = year ? `&year=${year}` : '';

    if (userType === LeaveHistoryUserType.User) {
      url += `user?userId=${userId}${yearQueryParam}`;
      return this.http.get<LeaveHistory>(url);
    } else if (userType === LeaveHistoryUserType.Manager) {
      url += `direct-reports?${yearQueryParam}`;
      return this.http.get<QueryResult>(url);
    } else {
      url += `self?${yearQueryParam}`;
      return this.http.get<LeaveHistory>(url);
    }
  }

  saveLeaveHistory(leaveHistory: LeaveHistory): Observable<LeaveHistory> {
    const url = '/hr/leave-histories/';
    return this.http.post<LeaveHistory>(url, leaveHistory);
  }

  saveOrUpdateLeaveDetail(leaveDetail: LeaveDetail): Observable<LeaveDetail> {
    let url = "/hr/leave-details";

    if (leaveDetail.id) {
      url += `/${leaveDetail.id}`;
      return this.http.put<LeaveDetail>(url, leaveDetail);
    } else {
      return this.http.post<LeaveDetail>(url, leaveDetail);
    }
  }

  updateLeaveHistory(leaveHistory: LeaveHistory): Observable<LeaveHistory> {
    const url = `/hr/leave-histories/${leaveHistory.id}`;
    return this.http.put<LeaveHistory>(url, leaveHistory);
  }

  deleteLeaveDetail(leaveDetailId: number): Observable<Response> {
    const url = `/hr/leave-details/${leaveDetailId}`;
    return this.http.delete<Response>(url);
  }
}
